import moment from "moment";

export function normalizeAuthorization(item) {
  const rawExpiry = item?.expiryDate;
  let expiryDate = "";
  if (rawExpiry) {
    const strict = moment(rawExpiry, "YYYY-MM-DD", true);
    const parsed = strict.isValid() ? strict : moment(rawExpiry);
    expiryDate = parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
  }

  return {
    authorizationNumber: item?.authorizationNumber || "",
    expiryDate,
  };
}

export function authorizationExpiryState(authorization) {
  if (!authorization?.expiryDate) return "missing";
  const strict = moment(authorization.expiryDate, "YYYY-MM-DD", true);
  const parsed = strict.isValid() ? strict : moment(authorization.expiryDate);
  if (!parsed.isValid()) return "missing";
  return parsed.endOf("day").valueOf() >= moment().startOf("day").valueOf()
    ? "valid"
    : "expired";
}

export function readAuthorizations(insuranceDetails) {
  if (!insuranceDetails || typeof insuranceDetails !== "object") {
    return [];
  }
  const fromList = Array.isArray(insuranceDetails.authorizations)
    ? insuranceDetails.authorizations
    : [];
  const fromCards = Array.isArray(insuranceDetails.cards)
    ? insuranceDetails.cards.flatMap((card) =>
        Array.isArray(card?.authorizations) ? card.authorizations : []
      )
    : [];
  const source = fromList.length ? fromList : fromCards;
  return source
    .map(normalizeAuthorization)
    .filter((item) => item.authorizationNumber || item.expiryDate);
}

export function getInsuranceAuthorizationStatus(insuranceDetails) {
  if (!insuranceDetails || insuranceDetails.hasInsurance !== "yes") {
    return { status: "none", authorizations: [] };
  }

  const authorizations = readAuthorizations(insuranceDetails);

  const dated = authorizations.filter(
    (item) => authorizationExpiryState(item) !== "missing"
  );
  const hasValid = dated.some(
    (item) => authorizationExpiryState(item) === "valid"
  );

  if (hasValid) return { status: "valid", authorizations };
  if (dated.length) return { status: "expired", authorizations };
  return { status: "missing", authorizations };
}
